<div class="dialog">
    <div class="dialog-header">
        同步文件
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    标段范围
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <format-data [contentStr]="cover" [patternStr]="'E+600'"></format-data>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    入库表单
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <format-data [contentStr]="formArchiveFileSyncRule.content ?? ''" [patternStr]="'E+600'">
                    </format-data>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    入库材料
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <nz-select nzShowSearch [nzDisabled]="true" nzMode="multiple"
                        [(ngModel)]="materialTypeListSelected">
                        <nz-option *ngFor="let item of materialTypeList" [nzValue]="item.id!" [nzLabel]="item.name!">
                        </nz-option>
                    </nz-select>

                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()">同步</button>
    </div>
</div>